import { Box, Button, Typography } from '@material-ui/core';

import { useStyles } from './styles';

interface Props {
  value: number;
  min?: number;
  max?: number;
  ariaLabel: string;
  onChange: (value: number) => void;
}

export const SettingsNumberStepper = ({ value, min = 1, max = 52, ariaLabel, onChange }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.stepper} role="group" aria-label={ariaLabel}>
      <Button
        className={classes.stepperButton}
        disabled={value <= min}
        aria-label={`Decrease ${ariaLabel}`}
        onClick={() => onChange(Math.max(min, value - 1))}
      >
        −
      </Button>

      <Typography component="span" className={classes.stepperValue}>
        {value}
      </Typography>

      <Button
        className={classes.stepperButton}
        disabled={value >= max}
        aria-label={`Increase ${ariaLabel}`}
        onClick={() => onChange(Math.min(max, value + 1))}
      >
        +
      </Button>
    </Box>
  );
};
